import React from 'react'
import PropTypes from 'prop-types'
import OpalTile from '../../../../opal/OpalTile'
import AdminPage from '../../../admin/shared/AdminPage'
import FlexRow from '../../../../molecules/FlexRow'
import PolicyLink from '../../../../atoms/PolicyLink'
import PolicyNotAvailable from '../../../../atoms/PolicyNotAvailable'

const adminDenaliInternal = 'admin_denali_internal'
const all = [adminDenaliInternal]

function DenaliAIIndexView ({ root }) {
  return (
    <AdminPage>
      <FlexRow className='items-center justify-center' style={{ flexWrap: 'wrap' }}>
        <PolicyLink to={`${root}/ai/skills`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali AI Skills
          </OpalTile>
        </PolicyLink>
        <PolicyNotAvailable policies={all} />
      </FlexRow>
    </AdminPage>
  )
}

DenaliAIIndexView.propTypes = {
  root: PropTypes.any
}

export default DenaliAIIndexView
